import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { snoozeTask, markDone, deleteTask } from '../api';
import { computeSnooze, type SnoozePreset } from '@jizhu/shared/reminder-time';

export default function TaskDetail() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const [showSnooze, setShowSnooze] = useState(false);
  const [busy, setBusy] = useState(false);

  async function snooze(preset: SnoozePreset) {
    setBusy(true);
    try {
      const { to_time } = computeSnooze(preset);
      await snoozeTask(id, to_time, preset);
      setShowSnooze(false);
      navigate('/');
    } catch (e: any) {
      alert('推迟失败: ' + e.message);
    } finally {
      setBusy(false);
    }
  }

  async function done() {
    setBusy(true);
    try {
      await markDone(id);
      navigate('/');
    } catch (e: any) {
      alert('完成失败: ' + e.message);
    } finally {
      setBusy(false);
    }
  }

  async function remove() {
    if (!confirm('确定要删除这个任务吗?')) return;
    setBusy(true);
    try {
      await deleteTask(id);
      navigate('/');
    } catch (e: any) {
      alert('删除失败: ' + e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="task-detail">
      <header>
        <button onClick={() => navigate(-1)}>← 返回</button>
      </header>
      <div className="actions">
        <button onClick={() => setShowSnooze(true)} disabled={busy}>⏰ 推迟</button>
        <button onClick={done} disabled={busy}>✓ 完成</button>
        <button onClick={remove} disabled={busy} className="danger">🗑 删除</button>
      </div>

      {showSnooze && (
        <div className="sheet-backdrop" onClick={() => setShowSnooze(false)}>
          <div className="sheet" onClick={e => e.stopPropagation()}>
            <h3>推迟到什么时候?</h3>
            <button onClick={() => snooze('15min')} disabled={busy}>15 分钟后</button>
            <button onClick={() => snooze('1h')} disabled={busy}>1 小时后</button>
            <button onClick={() => snooze('today_later')} disabled={busy}>今天晚些时候</button>
            <button onClick={() => snooze('tomorrow')} disabled={busy}>明天上午 9 点</button>
            <button onClick={() => snooze('next_monday')} disabled={busy}>下周一上午 9 点</button>
            <button onClick={() => setShowSnooze(false)}>取消</button>
          </div>
        </div>
      )}
    </div>
  );
}
